import React, { Component } from "react";
import { connect } from "react-redux";
import ImageContentHover from "react-image-hover";
import LetsWorkTogether from "components/LetsWorkTogether";
import { withTranslation } from "lib/i18n";
import Seo from "components/Seo";

class OurTeam extends Component {
  render() {
    const { t, language } = this.props.i18n;
    const isFrench = language === "fr";
    const title = isFrench ? "Notre équipe | Quivio" : "Our Team | Quivio";
    const description = isFrench
      ? "Rencontrez l'équipe Quivio d'ingénieurs logiciel et designers qui livrent du logiciel sur mesure."
      : "Meet the Quivio team of software engineers and designers delivering tailored software.";
    return (
      <>
        <Seo title={title} description={description} path="/team" />
        <section className="team section-title mt-5 text-white text-center">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-7 mx-auto">
                <div className="team-title mb-5 mt-5">
                  <h1 className="title-font title-font-size">{t("team.heading")}</h1>
                  <p className="title-text mt-4 mb-4 title-font-2">
                    {t("team.subheading")}
                  </p>
                </div>
              </div>
            </div>
            <div className="row align-items-center">
              {this.props.persons.map((person) => {
                const positionLabel = t(`team.positions.${person.positionKey}`) || person.position;
                return (
                // show portfoilo boxes by mapping the array of images
                <div className="col-lg-4 col-md-6 col-sm-12 person-box" key={person.id}>
                  <div className="portfolio-thumb" aria-hidden="true">
                    <ImageContentHover
                      className="center-block"
                      image={person.image}
                      content={{
                        title: [person.name],
                        body: [positionLabel],
                      }}
                      effect="fadeIn"
                    />
                  </div>
                  <div className="person-info mb-5">
                    <p className="person-name title-font-2"> {person.name} </p>
                    <p className="person-position title-font-2">
                      {positionLabel}
                    </p>
                  </div>
                </div>
                );
              })}
            </div>
          </div>
        </section>
        <LetsWorkTogether />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    persons: state.team,
  };
};

export default connect(mapStateToProps)(withTranslation(OurTeam));
